import React from 'react';
import { MessageSquareIcon, SlidersIcon, RocketIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function HowItWorks() {
  const {
    t
  } = useTranslation();
  const steps = [{
    icon: <MessageSquareIcon className="w-6 h-6" data-id="element-97" />,
    titleKey: 'howItWorks.step0Title',
    descKey: 'howItWorks.step0Desc'
  }, {
    icon: <SlidersIcon className="w-6 h-6" data-id="element-98" />,
    titleKey: 'howItWorks.step1Title',
    descKey: 'howItWorks.step1Desc'
  }, {
    icon: <RocketIcon className="w-6 h-6" data-id="element-99" />,
    titleKey: 'howItWorks.step2Title',
    descKey: 'howItWorks.step2Desc'
  }];
  return <section className="py-32 bg-[#050505] relative z-20 overflow-hidden" data-id="element-100">
      <div className="max-w-7xl mx-auto px-6" data-id="element-101">
        <div className="text-center mb-24" data-id="element-102">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-103">
            {t('howItWorks.title')}
          </h2>
          <p className="text-white/60 text-lg" data-id="element-104">{t('howItWorks.subtitle')}</p>
        </div>

        <div className="relative" data-id="element-105">
          <div className="absolute top-10 left-[15%] right-[15%] h-0.5 hidden md:block" data-id="element-106">
            <div className="absolute inset-0 bg-white/10" data-id="element-107"></div>
            <div className="absolute inset-0 bg-gradient-animated opacity-70" data-id="element-108"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-109">
            {steps.map((step, idx) => <div key={idx} className="flex flex-col items-center text-center" data-id="element-110">
                <div className="relative mb-8" data-id="element-111">
                  <div className="absolute inset-0 rounded-full animate-pulse-glow bg-gradient-animated blur-xl" data-id="element-112"></div>
                  <div className="w-20 h-20 rounded-full bg-[#111] border border-white/20 flex items-center justify-center relative z-10 text-white" data-id="element-113">
                    {step.icon}
                  </div>
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gradient-animated flex items-center justify-center text-xs font-bold text-white z-20 shadow-lg" data-id="element-114">
                    0{idx + 1}
                  </div>
                </div>
                <h3 className="text-2xl font-bold mb-3" data-id="element-115">{t(step.titleKey)}</h3>
                <p className="text-white/60 leading-relaxed max-w-[250px]" data-id="element-116">
                  {t(step.descKey)}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}